__webpack_require__.p = "/adaptive_menu/";